import { SchedulePartialStoreState, SCHEDULE_STATE_KEY } from '../schedule.reducer';

export const getPreviousSearch = (state: SchedulePartialStoreState) =>
    state[SCHEDULE_STATE_KEY].routeSearch.previousSearch;
